// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const resetCreditMemoReport = () =>
    (dispatch, getState) => {

        const dealers = getState().user.details.settings.dealer.accounts.selectedAccounts;

        dispatch({
            type: actions.RESET_CREDIT_MEMO_REPORT
        });

        dispatch({
            dealers,
            type: actions.SELECT_ALL_CREDIT_MEMO_DEALERS_ON_LOAD
        });

    };

export const selectAllCreditMemoClaimTypes = () => ({
    type: actions.SELECT_ALL_CREDIT_MEMO_CLAIM_TYPES
});

export const selectCreditMemoClaimType = (claimType, isSelected) => ({
    claimType,
    isSelected,
    type: actions.SELECT_CREDIT_MEMO_CLAIM_TYPE
});

export const selectCreditMemoIssueDate = creditMemoIssueDate => ({
    creditMemoIssueDate,
    type: actions.SELECT_CREDIT_MEMO_ISSUE_DATE
});

export const updateCreditMemoCriteria = (attribute, value) => ({
    attribute,
    type: actions.UPDATE_CREDIT_MEMO_CRITERIA,
    value
});



// WEBPACK FOOTER //
// ./src/reports/credit-memo/action-creators/criteria.js